import CheckboxCell from '@app/src/components/Table/Cells/CheckboxCell'
import type { CompanyCellProps } from '@app/src/components/Table/Cells/CompanyCell'
import CompanyCell from '@app/src/components/Table/Cells/CompanyCell'
import type { ResponseItem } from '@app/src/types/resourceExplorer'
import { TableRow } from '@mui/material'
import type { ReactNode } from 'react'
import React from 'react'
import type { ResponseItemRowProps } from './ResponseItemRow'
import ResponseItemRow from './ResponseItemRow'
import LinkCell from '@app/src/components/Table/Cells/LinkCell'
import paths from '@app/src/wf-constants/paths'
import ValueCell from '@app/src/components/Table/Cells/ValueCell'
import { generatePath } from 'react-router-dom'

interface ResponseItemCompanyRowProps extends ResponseItemRowProps, Pick<CompanyCellProps, 'drawer'> {
  selectedRowsIds?: Array<number>
  onCheckboxChange?: (e: React.ChangeEvent<HTMLInputElement>, responseItem: ResponseItem) => void
  disableRowSelection?: boolean
  additionalColumn?: ReactNode
  showTargetProductColumn?: boolean
}

export const ResponseItemCompanyRow = ({
  row: responseItem,
  drawer = true,
  showAnswerClassificationResults,
  selectedRowsIds,
  onCheckboxChange,
  disableRowSelection,
  additionalColumn,
  showTargetProductColumn,
}: ResponseItemCompanyRowProps): JSX.Element => {
  const isChecked = Boolean(selectedRowsIds?.find(requestId => requestId === responseItem.id))

  return (
    <TableRow selected={isChecked}>
      {!disableRowSelection && <CheckboxCell checked={isChecked} onChange={e => onCheckboxChange?.(e, responseItem)} />}
      <CompanyCell
        company={{
          ...responseItem.response.request.targetAliasObject,
          organization: responseItem.response.request.targetObject,
        }}
        drawer={drawer}
      />
      {showTargetProductColumn &&
        (responseItem.response.request.targetProduct ? (
          <LinkCell
            label={responseItem.response.request.targetProduct?.name}
            to={generatePath(paths.product, {
              id: responseItem.response.request.targetProduct?.id,
            })}
          />
        ) : (
          <ValueCell />
        ))}
      {additionalColumn}
      <ResponseItemRow
        row={responseItem}
        disableTableRow
        showAnswerClassificationResults={showAnswerClassificationResults}
      />
    </TableRow>
  )
}

export default ResponseItemCompanyRow
